import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import CardSectionHeading from '../CardSectionHeading';
import CardRowKeyVal from '../CardRowKeyVal';
import moment from 'moment-timezone';
import get from 'lodash/get';

const propTypes = {
  details: PropTypes.shape({
    modal_name: PropTypes.string,
  }),
};

const defaultProps = {
  details: {},
};

class PolicyDetailsSmartphone extends PureComponent {

  get coverageStartDate() {
    return moment(this.props.coverage_start_date).tz('UTC').format('MMM DD, YYYY');
  }

  get coverageEndDate() {
    return moment(this.props.coverage_end_date).tz('UTC').format('MMM DD, YYYY');
  }

  render() {
    const {
      details,
      plan,
    } = this.props;

    return (
      <div>
        <CardRowKeyVal
          title="Coverage period"
          detail={`From ${this.coverageStartDate} to ${this.coverageEndDate}`}
        />
        <CardSectionHeading>
          Device Details
        </CardSectionHeading>
        <CardRowKeyVal
          title="Device"
          detail={get(details, 'modal_name')}
        />
        <CardSectionHeading>
          Policy Selections
        </CardSectionHeading>
        <CardRowKeyVal
          title="Plan type"
          detail={get(plan, 'title')}
        />
        <CardRowKeyVal
          title="Coverage"
          detail={get(plan, 'subtitle')}
        />
      </div>
    );
  }
}

PolicyDetailsSmartphone.propTypes = propTypes;
PolicyDetailsSmartphone.defaultProps = defaultProps;

export default PolicyDetailsSmartphone;
